import { useMemo } from 'react';
import { useQuery } from 'react-query';

import { vendorKeys } from '@config/queryKeys';
import { useOrderApi, useScheduleApi } from '@hooks/api';

import { useVendor } from './';

import type { CountResponse } from '@services/api/types';
import type { VendorCountType } from 'types/vendors';
export function useVendorCount(type: VendorCountType) {
  const orderApi = useOrderApi();
  const scheduleApi = useScheduleApi();
  const { vendor } = useVendor();
  const { data, isFetched, isFetching, isLoading, refetch } = useQuery<
    CountResponse,
    null
  >(
    vendorKeys.count(vendor.id, type),
    () => {
      switch (type) {
        case 'invoices':
          return orderApi.count({
            merchantIds: vendor?.id,
            types: 'invoice,quote',
          });

        case 'orders':
          return orderApi.count({
            merchantIds: vendor?.id,
            types: 'online,walkup,walkup-cash',
          });

        case 'schedules':
          return scheduleApi.count({
            vendorId: vendor?.id,
          });
      }
    },
    {
      enabled: !!type && !!vendor?.id,
    }
  );

  const count = useMemo(() => {
    if (typeof data?.count?.total === 'number') {
      return data.count.total;
    }

    if (typeof data?.total === 'number') {
      return data.total;
    }

    return undefined;
  }, [data?.count?.total, data?.total]);

  return {
    count,
    isFetched,
    isFetching,
    isLoading,
    refetch,
  };
}
